import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import cc from 'classcat';
import ready from '../../utils/dom/ready';
import css from './Hero.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Hero = function Hero() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      animationOn = _useState2[0],
      setAnimationOn = _useState2[1];

  useEffect(function () {
    ready(function () {
      setAnimationOn(true);
    });
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.hero, _defineProperty({}, css.animate, animationOn)]),
    children: [/*#__PURE__*/_jsx("span", {
      children: "You can"
    }), /*#__PURE__*/_jsx("div", {
      className: css.border,
      children: /*#__PURE__*/_jsx("div", {
        className: css.slider,
        children: /*#__PURE__*/_jsxs("ul", {
          className: css.words,
          children: [/*#__PURE__*/_jsx("li", {
            className: css.word,
            children: "hike"
          }), /*#__PURE__*/_jsx("li", {
            className: css.word,
            children: "run"
          }), /*#__PURE__*/_jsx("li", {
            className: css.word,
            children: "skate"
          }), /*#__PURE__*/_jsx("li", {
            className: css.word,
            children: "surf"
          }), /*#__PURE__*/_jsx("li", {
            className: css.word,
            children: "send it"
          }), /*#__PURE__*/_jsx("li", {
            className: css.word,
            children: "do anything"
          })]
        })
      })
    }), /*#__PURE__*/_jsx("span", {
      children: "in a dress."
    })]
  });
};

export default Hero;